<script>
  import { format } from 'svelte-i18n';

  import { FieldHeader, FieldLabel } from '@client/components/fields/standalone/base';

  import { appSettingsStore } from '@client/stores/page-settings';

  import { DEFAULT_SIZE, DISPLAY_SIZES } from '@client/enums';

  /**
   * Callback function to handle display size updates.
   * @type {function}
   */
  export let onDisplayUpdate = () => {};

  /**
   * Handle click event to update display size.
   * @param selected
   */
  const onClick = (selected) => onDisplayUpdate(selected);

  /**
   * Set the selected display size from the store or default value.
   * @type {string}
   */
  $: selected = $appSettingsStore.displaySize || DEFAULT_SIZE.value;
</script>

<div class="display-field">
  <FieldHeader>
    <FieldLabel label={$format('label.DISPLAY_SIZE')} />
  </FieldHeader>

  <div class="preview-grid">
    {#each DISPLAY_SIZES as item}
      <div
        class="tile"
        class:selected={selected === item.value}
        role="button"
        tabindex="0"
        on:click={() => onClick(item)}
      >
        <div class="preview {item.class}">
          <div class="text">{$format('label.DISPLAY_TEXT_PLACEHOLDER')}</div>
        </div>
        <div class="name">{$format(item.label)}</div>
      </div>
    {/each}
  </div>
</div>

<style lang="scss" src="./display-size.scss"></style>
